import { WebSocketReceiveMessage } from './web-socket-receive-message';

export class WebSocketReceiveBadgeIds extends WebSocketReceiveMessage {
  override payload: {
    ids: string[];
  };

  getBadgeIds(): string[] {
    return this.payload?.ids ?? [];
  }
}
